
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useNewsletter } from "@/hooks/use-newsletter";
import { Mail, Check, Loader2 } from "lucide-react";

export const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const { isLoading, isSubscribed, subscribe, resetState } = useNewsletter();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const success = await subscribe(email);
    if (success) {
      setEmail("");
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (isSubscribed) {
      resetState();
    }
  };

  if (isSubscribed) {
    return (
      <div className="flex items-center justify-center gap-3 max-w-md mx-auto p-4 bg-green-50 rounded-lg border border-green-200">
        <div className="flex items-center justify-center w-8 h-8 bg-green-100 rounded-full">
          <Check className="w-5 h-5 text-green-600" />
        </div>
        <div className="text-center">
          <p className="text-green-800 font-medium">Inscription réussie !</p>
          <p className="text-green-600 text-sm">Merci de vous être abonné à notre newsletter.</p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex gap-4 max-w-md mx-auto">
      <div className="flex-1">
        <Input 
          type="email" 
          placeholder="Votre adresse email"
          value={email}
          onChange={handleEmailChange}
          disabled={isLoading}
          className="w-full"
          required
        />
      </div>
      <Button 
        type="submit" 
        disabled={isLoading || !email.trim()}
        className="flex items-center gap-2"
      >
        {isLoading ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            Inscription...
          </>
        ) : (
          <>
            <Mail className="w-4 h-4" />
            S'abonner
          </>
        )}
      </Button>
    </form>
  );
};
